import { MapType } from '@cobliteam/common-types';
import { type Draft, produce } from 'immer';
import type L from 'leaflet';
import type { Reducer } from 'redux';
import type { MapAction } from './actions';
import { MapActionNames } from './actionTypes';
import type { MapPopup } from './types';

export interface MapState {
  openPopup: MapPopup | null;
  zoomLevel: number | null;
  mapType: MapType;
  mapLicensePlate: boolean;
  mapTraffic: boolean;
  mapRef: any;
  drawLayers: L.Layer[];
  mapStyle: {
    asset: 'default' | 'balanced' | 'minimal';
    color: 'default' | 'dark' | 'light' | 'grayscale';
  };
}

export const mapInitialState: MapState = {
  openPopup: null,
  zoomLevel: null,
  mapType: MapType.ROADMAP,
  mapTraffic: false,
  mapLicensePlate: false,
  mapRef: undefined,
  drawLayers: [],
  mapStyle: {
    asset: 'default',
    color: 'default',
  },
};

export const mapReducer: Reducer<MapState, MapAction> = produce((draft: Draft<MapState>, action: MapAction) => {
  switch (action.type) {
    case MapActionNames.SET_OPEN_POPUP: {
      const { entity, id } = action.payload;
      const openPopup = entity && id ? { entity, id } : null;
      draft.openPopup = openPopup;
      break;
    }

    case MapActionNames.SET_ZOOM_LEVEL:
      draft.zoomLevel = action.payload;
      break;

    case MapActionNames.CHANGE_MAP_TYPE:
      draft.mapType = action.payload;
      break;

    case MapActionNames.CHANGE_MAP_TRAFFIC:
      draft.mapTraffic = action.payload;
      break;

    case MapActionNames.CHANGE_MAP_LICENSE_PLATE:
      draft.mapLicensePlate = action.payload;
      break;

    case MapActionNames.CHANGE_MAP_REF:
      draft.mapRef = action.payload;
      break;

    case MapActionNames.CHANGE_DRAW_LAYERS:
      draft.drawLayers = action.payload;
      break;

    case MapActionNames.CHANGE_MAP_STYLE:
      if (action.payload.asset !== undefined) {
        draft.mapStyle.asset = action.payload.asset;
      }
      if (action.payload.color !== undefined) {
        draft.mapStyle.color = action.payload.color;
      }
      break;
  }
}, mapInitialState);
